<template>
    <div>
        <v-card style="min-height:300px">
            <v-toolbar flat color="info" height="50" >
                <v-toolbar-title>
                    Item Price Picker
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon color="primary" @click.prevent="onPicked()">
                    <v-icon>clear</v-icon>
                </v-btn>
            </v-toolbar>

            <v-layout row >
                <v-flex xs12>
                    <v-text-field 
                        v-model="facilityPriceLevelToSearch" 
                        label="Price Level"
                        ></v-text-field>
                </v-flex>
                <v-flex xs12>
                    <v-btn @click.prevent="searchItems">Find Prices</v-btn>
                </v-flex>
            </v-layout>     
            <v-card-text v-show="entries.length">
                <h3>Please Pick below:</h3>
                <v-data-table
                    :items="entries"
                    item-key="id"
                    :pagination.sync="pagination"
                    :rows-per-page-items="pagination.rowsPerPageItems"
                    disable-initial-sort
                    hide-headers
                >
                    <template slot="items" slot-scope="props">
                    <tr>
                        <td style="padding:1px;margin:1px">
                            <v-btn large @click.prevent="onPicked(props.item)" class="primary" style="padding:1px;margin:1px">Pick</v-btn>
                        </td>
                        <td class="text-xs-left">
                            <div class="body-1">
                                Price Level: {{ props.item.priceLevel }}
                            </div>
                            <div class="body-1">
                                Unit: {{ props.item.uofm }}
                            </div>
                            <div>
                                Price: {{ props.item.uofmPrice }}
                            </div>
                        </td>
                        <!-- <td class="text-xs-right">{{ props.item.totalMainSalesAmt? props.item.totalMainSalesAmt : 'n/a' | currency}}</td>
                        <td class="text-xs-right">{{ props.item.totalMainCommiAmt? props.item.totalMainCommiAmt : 'n/a' | currency}}</td>
                        <td class="text-xs-right">{{ props.item.totalMainPercent? props.item.totalMainPercent : '' }}</td>
                        <td class="text-xs-right">{{ props.item.createDate }}</td>
                        <td class="text-xs-right">{{ props.item.createBy }}</td> -->
                    </tr>
                    </template>
                </v-data-table>  
            </v-card-text>
           

        </v-card>
    </div>
</template>
<script>
// import _ from "lodash"
import { mapActions } from 'vuex'

export default {
    props: ['itemId', 'facilityPriceLevel', 'qty'],
    data () {
        return {
            facilityPriceLevelToSearch: '',
            entries: [],
            pagination: {
                descending: true,
                page: 1,
                rowsPerPage: 10,
                sortBy: '',
                totalItems: 0,
                rowsPerPageItems: [10, 20, 50]
            },
            headers: [
            ],
        }
    },
    computed: {
    },
    methods: {
        ...mapActions('itemSearch',[
            'searchItemPrices'
        ]),
        onPicked(itemPicked) {
            this.$emit('onItemPricePicked', itemPicked)
            // reset data
            // this.keyword = ''
            this.entries = []
        },
        async searchItems() {

            var payload = {
                facilityPriceLevel: this.facilityPriceLevelToSearch,
                itemId: this.itemId,
                qty: this.qty,
            }
            let FacilitysFound = await this.searchItemPrices(payload);
            // console.log(`FacilitysFound: ${FacilitysFound.length}`)
            this.count = FacilitysFound.length
            this.entries = FacilitysFound

            // this.isLoading = false
        }, 
    },
    watch: {
        facilityPriceLevel : function(newVal, oldVal) {
            this.facilityPriceLevelToSearch = newVal
        }
    }
}
</script>
